import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginScreen from './pages/LoginScreen';
import CheckInScreen from './pages/CheckInScreen';
import ClientIntake from './pages/ClientIntake';
import Unauthorized from './pages/Unauthorized';
import ThankYou from './pages/ThankYou';

function AppRoutes() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  // Client intake is public
  const path = window.location.pathname;
  if (path === '/client-intake') {
    return <ClientIntake />;
  }
  if (path === '/thank-you') {
    return <ThankYou />;
  }

  if (!isAuthenticated) {
    return <LoginScreen />;  // Directly render LoginScreen
  }

  return (
    <Routes>
      <Route path="/" element={<CheckInScreen />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;